const routes = [
  {
    name: 'progressApp',
    path: '/progress/pages/entry/entry-middle-app',
    component: () => import('@pages/progress/main-app'),
  },
  {
    name: 'progressWechat',
    path: '/progress/pages/entry/entry-middle-wechat',
    component: () => import('@pages/progress/main-wechat'),
  },
  {
    name: 'progressSign',
    path: '/progress/sign',
    component: () => import('@pages/progress/sign'),
  },
  {
    name: 'progressInterview',
    path: '/progress/interview',
    component: () => import('@pages/progress/interview'),
  },
  {
    name: 'progressWaitTrain',
    path: '/progress/wait-train',
    component: () => import('@pages/progress/wait-train'),
  },
  {
    name: 'progressTrain',
    path: '/progress/train',
    component: () => import('@pages/progress/train'),
  },
  {
    name: 'progressTrainSuccess',
    path: '/progress/train-success',
    component: () => import('@pages/progress/train-success'),
  },
  {
    name: 'progressEntry',
    path: '/progress/entry',
    component: () => import('@pages/progress/entry'),
  },
  {
    name: 'progressEntrySuccess',
    path: '/progress/entry-success',
    component: () => import('@pages/progress/entry-success'),
  },
  {
    name: 'progressRecycle',
    path: '/progress/recycle',
    component: () => import('@pages/progress/recycle'),
  },
  {
    name: 'progressRecycleWeedOut',
    path: '/progress/recycleWeedOut',
    component: () => import('@pages/progress/recycleWeedOut'),
  },
  {
    name: 'progressRecycleSelfReject',
    path: '/progress/recycleSelfReject',
    component: () => import('@pages/progress/recycleSelfReject'),
  },
  {
    name: 'progressCourse',
    path: '/progress/course',
    component: () => import('@pages/progress/course'),
  },
];

export default routes;
